
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accueil",
      function () {
        return require("private-next-pages/accueil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accueil"])
      });
    }
  